(function () {
  var STORAGE_KEY = "akro_store_choice";
  var COOKIE_NAME = "akro_store_choice";
  var COOKIE_DOMAIN = ".akrofragrances.com";

  if (window.location.hostname !== "us.akrofragrances.com") return;

  // Ne pas gêner le theme editor
  if (window.Shopify && Shopify.designMode) return;

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; domain=" + COOKIE_DOMAIN + "; SameSite=Lax";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  var forceGate = window.location.search.includes("gate=1");
  var existingChoice = getCookie(COOKIE_NAME) || localStorage.getItem(STORAGE_KEY);

  if (existingChoice && !forceGate) return;

  // Évite les bots (SEO)
  var ua = navigator.userAgent.toLowerCase();
  if (ua.includes("bot") || ua.includes("crawl") || ua.includes("spider")) return;

  function lockScroll() {
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }

  function unlockScroll() {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  }

  function saveChoice(value) {
    localStorage.setItem(STORAGE_KEY, value);
    setCookie(COOKIE_NAME, value, 30);
  }

  function openGate() {
    var gate = document.getElementById("StoreGate");
    if (!gate) return;

    gate.hidden = false;
    lockScroll();

    gate.addEventListener("click", function (e) {
      var choice = e.target && e.target.getAttribute("data-gate-choice");
      if (!choice) return;

      if (choice === "us") {
        saveChoice("us");
        unlockScroll();
        gate.hidden = true;

        window.dispatchEvent(new Event("akro:gateClosed"));
        return;
      }

      if (choice === "global") {
        saveChoice("global");
        window.location.href = "https://akrofragrances.com";
        return;
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", openGate);
  } else {
    openGate();
  }
})();